/* assets/mm-swirl-hero.js — <mm-swirl-hero>: Sortenschalter
 * Pill wählt Sorte → aria-pressed, Dosen tauschen (Front/Back), Kreis + Badge folgen der Fruchtfarbe,
 * Primär-Button-Label aktualisiert, Preis-Sticker der Sorte. Seitenweit: --mm-fruit/-light/-dark auf <html>
 * und Event mm:flavor-change {name, key, colors, index, layerTitle, layerText}. Start per Setting oder ?flavor=. */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('mm-swirl-hero')) return;

  class MMSwirlHero extends HTMLElement {
    connectedCallback() {
      try { this.flavors = JSON.parse(this.querySelector('[data-mm-flavor-data]').textContent); } catch (e) { this.flavors = []; }
      if (!this.flavors.length) return;
      this.pills = Array.prototype.slice.call(this.querySelectorAll('[data-mm-flavor]'));
      this.cans = Array.prototype.slice.call(this.querySelectorAll('[data-mm-can]'));
      this.stickers = Array.prototype.slice.call(this.querySelectorAll('[data-mm-sticker]'));
      this.cta = this.querySelector('[data-mm-cta]');
      this.template = this.dataset.primaryTemplate || '{flavor}';
      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);

      var start = parseInt(this.dataset.start, 10) || 0;
      var param = this.dataset.urlParam || 'flavor';
      try {
        var q = new URLSearchParams(window.location.search).get(param);
        if (q) { var hit = this.flavors.findIndex(function (f) { return f.key === q.toLowerCase() || f.name.toLowerCase() === q.toLowerCase(); }); if (hit >= 0) start = hit; }
      } catch (e) {}
      this.select(start, true);
    }

    disconnectedCallback() { this.removeEventListener('click', this._onClick); }

    _onClick(evt) {
      var pill = evt.target.closest('[data-mm-flavor]');
      if (!pill || !this.contains(pill)) return;
      this.select(parseInt(pill.dataset.mmFlavor, 10), false);
    }

    select(index, silent) {
      var f = this.flavors[index]; if (!f) return;
      var previous = this.current;
      this.current = index;
      var self = this;

      this.pills.forEach(function (p) { p.setAttribute('aria-pressed', parseInt(p.dataset.mmFlavor, 10) === index ? 'true' : 'false'); });

      // Dosen: aktive nach vorn, die zuletzt aktive (oder die nächste) nach hinten, Rest ausblenden
      var back = previous !== undefined && previous !== index ? previous : (index + 1) % this.flavors.length;
      this.cans.forEach(function (img) {
        var i = parseInt(img.dataset.mmCan, 10);
        img.classList.toggle('is-front', i === index);
        img.classList.toggle('is-back', i === back && i !== index);
        img.classList.toggle('is-hidden', i !== index && i !== back);
      });
      this.stickers.forEach(function (s) { s.hidden = parseInt(s.dataset.mmSticker, 10) !== index; });

      if (this.cta) this.cta.textContent = this.template.replace('{flavor}', f.name);

      var root = document.documentElement.style;
      root.setProperty('--mm-fruit', f.fruit);
      root.setProperty('--mm-fruit-light', f.light);
      root.setProperty('--mm-fruit-dark', f.dark);
      var section = this.closest('.mm-section');
      if (section) { section.style.setProperty('--mm-fruit', f.fruit); section.style.setProperty('--mm-fruit-light', f.light); section.style.setProperty('--mm-fruit-dark', f.dark); }

      document.dispatchEvent(new CustomEvent('mm:flavor-change', { detail: { name: f.name, key: f.key, index: index, colors: { fruit: f.fruit, light: f.light, dark: f.dark }, layerTitle: f.layerTitle, layerText: f.layerText } }));
      if (!silent && window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'mm_flavor_toggle', flavor: f.key });
      }
    }
  }

  customElements.define('mm-swirl-hero', MMSwirlHero);
})();
